import AOS from "aos";
import "aos/dist/aos.css";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Services from "./Pages/Services";
import React, { useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PriceList from "./Pages/PriceList";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GetFreeConsultation from "./components/GetFreeConsultation";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 200,
    });
  }, []);

  return (
    <div className="overflow-hidden">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/priceList" element={<PriceList />} />
          <Route path="/services" element={<Services />} />
        </Routes>
        <GetFreeConsultation />
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
